<template>
  <Cursor />
  <Sun />
  <Diamonds />
  <main>
    <h1 id="title1">NUMA VERPILLON</h1>
    <h2 id="title2">WEB DEVELOPER</h2>
    <div class="main-ctn">
      <Projects />
      <Moi />
      <Competences />
    </div>
  </main>
  <Footer />
</template>

<script>
import lenis from "@/lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Diamonds from "@/components/Diamonds.vue";
import Cursor from "@/components/Cursor.vue";
import Sun from "@/components/Sun.vue";
import Projects from "@/components/Projects.vue";
import Competences from "@/components/Competences.vue";
import Footer from "@/components/Footer.vue";
import Moi from "@/components/Moi.vue";

export default {
  name: "AppMain",
  components: {
    Moi, Cursor, Sun, Diamonds, Projects, Competences, Footer
  },
  mounted () {
    //Initialisation : gsap et ScrollTrigger
    gsap.registerPlugin(ScrollTrigger);

    // EFFET SCROLL
    lenis.on('scroll', () => {
      const scrollY = window.scrollY;

      gsap.to('.layer1', {
        y: scrollY * 0.05,
      });
      gsap.to('.layer2', {
        y: scrollY * 0.15,
      });
      gsap.to('#sun', {
        top: `calc(2% + ${scrollY / 12}px)`,
        right: `calc(8% - ${scrollY / 2}px)`,
      });
    });

    gsap.to(".bigContainer", {
      scrollTrigger: {
        trigger: "#competences",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      y:"60vh",
    });

    //ANIMATION D'APPARITION DU TITRE
    window.addEventListener('load', () => {
      gsap.fromTo('#title1',
          {
            opacity: 0,
            x: -100
          },
          {
            opacity: 1,
            x: 0,
            duration: 3,
            ease: 'power2.out',
          }
      );

      gsap.fromTo('#title2',
          {
            opacity: 0,
            x: 100
          },
          {
            opacity: 1,
            x: 0,
            duration: 3,
            ease: 'power2.out',
          }
      );
    });

    // MOUVEMENT DU FOND
    document.addEventListener('mousemove', (e) => {
      const { clientX: x, clientY: y } = e;

      gsap.to('.layer1', {
        x: x * 0.005,  // Mouvement léger
        y: y * 0.005
      });

      gsap.to('.layer2', {
        x: x * 0.015,  // Mouvement léger
        y: y * 0.015
      });
    });

    // ANIMATION D'APPARITION DES TITRES
    document.querySelectorAll(".slide-reveal").forEach((e) => {
      gsap.fromTo(e,
          {
            clipPath: "inset(0 100% 0 0)",
          },
          {
            clipPath: "inset(0 0 0 0)",
            scrollTrigger: {
              trigger: e,
              start: "top bottom",
              end: "bottom bottom",
              scrub: true,
            }
          }
      )
    });

    // ANIMATION D'APPARITION DES PROJETS
    document.querySelectorAll(".project").forEach((e) => {
      gsap.fromTo(e,
          {
            opacity: 0,
            x: -100
          },
          {
            opacity: 1,
            x: 0,
            scrollTrigger: {
              trigger: e,
              start: "top bottom",
              end: "bottom 90%",
              scrub: true,
            }
          }
      )
    });
  },
  beforeUnmount() {
    gsap.set("body", { height: "auto" });
  }
};
</script>

<style>
  main{
    margin-bottom: 8vh;
  }

  .main-ctn {
    position: relative;
    z-index: 0;
  }

  /* Style du titre */
  .slide-reveal {
    position: relative;
    overflow: hidden;
    transition: clip-path 0.75s ease-out;
  }
</style>